function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import defaultGlobals from './styles/defaultGlobals';
import IPT from 'react-immutable-proptypes';
import memoize from './unaryMemoize';
import React from 'react';
import RPT from 'prop-types';
import { Map, fromJS } from 'immutable';
var ThemeProvider = /*#__PURE__*/
function (_React$Component) {
  _inherits(ThemeProvider, _React$Component);
  function ThemeProvider(props, context) {
    var _this;
    _classCallCheck(this, ThemeProvider);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemeProvider).call(this, props, context));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "emptyStyleMap", Map());
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "themeId", Math.random());
    if (process.env.STORYBOOK_LIVE_STYLE_RELOAD) {
      _assertThisInitialized(_assertThisInitialized(_this))._getChildContext = _this._getChildContext.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    } else {
      _assertThisInitialized(_assertThisInitialized(_this))._getChildContext = memoize(_this._getChildContext.bind(_assertThisInitialized(_assertThisInitialized(_this))));
    }
    return _this;
  }
  _createClass(ThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return this._getChildContext(this.sanitizeObject(this.props.theme) || this.sanitizeObject(this.props.style) || this.emptyStyleMap);
    }
  }, {
    key: "_getChildContext",
    value: function _getChildContext(theme) {
      var includeQaClassNames = this.props.includeQaClassNames;
      var id = "".concat(theme.get('name')).concat(this.themeId);
      var themeStyle = theme.set('globals', defaultGlobals.mergeDeep(theme.get('globals'))).set('id', id);
      return {
        themeStyle: themeStyle,
        includeQaClassNames: includeQaClassNames
      };
    }
  }, {
    key: "sanitizeObject",
    value: function sanitizeObject(obj) {
      if (obj) {
        return Map.isMap(obj) ? obj : fromJS(obj);
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      if (!children) {
        return null;
      }
      return React.createElement(React.Fragment, null, children);
    }
  }]);
  return ThemeProvider;
}(React.Component);
_defineProperty(ThemeProvider, "childContextTypes", {
  themeStyle: IPT.map,
  includeQaClassNames: RPT.bool
});
_defineProperty(ThemeProvider, "defaultProps", {
  includeQaClassNames: false
});
export { ThemeProvider as default };